import { utilsModule } from "../utils-module";

utilsModule.factory('reportsService',['serverAddress',function(serverAddress){

    return {
        // RELATÓRIOS DO ORDERS
        getReportsUrl : function(fileName){
            return serverAddress.nodeURL + "/ReportsContainers/Relatorios/download/"+fileName;
        },

        getTagReportUrl : function(tagFileName){
            return serverAddress.nodeURL + "/ReportsContainers/Etiquetas/download/"+tagFileName;
        },

        getCouponReportUrl : function(tagFileName){
            return serverAddress.nodeURL + "/ReportsContainers/Cupons/download/"+tagFileName;
        },

        getPackageStatementReportUrl : function(statementFileName){
            return serverAddress.nodeURL + "/ReportsContainers/Cupons/download/"+statementFileName;
        },


        //RELATÓRIOS DO MANAGER
        getIdentityCardReportUrl:function(reportFileName:string){
            return serverAddress.managerURL + "/ReportsContainers/IdentityCards/download/"+reportFileName;
        },

        //RELATÓRIOS DO PACKING
        getTransferenceCouponReportUrl:function(reportFileName:string){
            return serverAddress.packingURL + "/ReportsContainers/Coupons/download/"+reportFileName;
        },
        getPackingGeneralReportsUrl:function(reportFileName:string){
            return serverAddress.packingURL + "/ReportsContainers/Reports/download/"+reportFileName;
        },

        //RELATÓRIOS DO ACCOUNTS
        getAccountsGeneralReportsUrl:function(reportFileName:string){
            return serverAddress.accountsURL + "/ReportsContainers/Reports/download/"+reportFileName;
        }
    }
}])